import { formatBusinessDate } from "../../utils/date"

export const ACTIVE_VIEW_TAB = 'view:active'
export const ALL_VIEW_TAB = 'view:all'
export const ALL_VIEW = 'all'

const ACTIVE_VIEW = 'active'
const LEAD_STATUS_FILTER_TYPE = 'leadDisposition'
const LEAD_CONTACT_STATUSES = ['newLead', 'duplicate']
const CHANGE_FAILED_MESSAGE = 'Lead status could not be changed.'
const CHANGE_SUCCESS_MESSAGE = 'Disposition successfully changed!'

export const isClosedStatus = (row) => row?.group === 'closed'

export const hasLeadStatusFilter = (filters) =>
  Array.isArray(filters) && filters.some((filter) => filter?.filterType === LEAD_STATUS_FILTER_TYPE)

export const requestDispositionView = ({ pipelineOn, disposition, dispositionView, filters }) =>
  pipelineOn && !disposition && dispositionView !== ALL_VIEW && !hasLeadStatusFilter(filters)
    ? ACTIVE_VIEW
    : undefined

export const changeDispositionOutcome = (result) => {
  if (result?.error) {
    const serverMessage = typeof result.payload === 'string' && result.payload ? result.payload : null
    return { ok: false, message: serverMessage || CHANGE_FAILED_MESSAGE }
  }
  return { ok: true, message: CHANGE_SUCCESS_MESSAGE }
}

export const isLeadContact = (status) => LEAD_CONTACT_STATUSES.includes(status?.value)

export const changedByLine = (change) => {
  if (!change?.at) return null
  const name = [change.by?.firstName, change.by?.lastName].filter(Boolean).join(' ') || 'someone'
  return `Changed by ${name} on ${formatBusinessDate(change.at)}`
}
